module.exports = __webpack_public_path__ + "static/media/product1.081bf019.jpg";